// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-add-team {
    padding: var(--space-x2-and-half) var(--space);
}

.profile-add-team__search {
  display: flex;
  justify-content: center;
  margin-bottom: var(--space-and-half);
}
.profile-add-team__search_title{
  margin-left: 20%;
}

.profile-add-team__search_title.baloa-names{
  margin-bottom: var(--space-half);
  color: var(--basic-gray-color);
}

.profile-add-team__container  {
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  width: 60%;
  height: 2.8rem;
}

.profile-add-team__search-input  {
  width: 80%;
  border: 2px solid #ECECEC;
  background: #ECECEC;
  border-radius: 5px 0 0 5px;
  border-right: transparent;
  padding: 7px;
  font-family: var(--secondary-font);
  font-size: var(--space);
}

.profile-add-team__search-button  {
  width: 20%;
  padding: 5px;
  background-color: #74837C;
  border: 1px solid transparent;
}

.profile-add-team__search-button:hover{
  cursor: pointer;
}

.profile-add-team__search-button.baloa-table{
  color: var(--white-color);
}

.profile-add-team__list {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: var(--space-and-half);
  column-gap: var(--space-quarter);
  grid-row-gap: var(--space-half);
  row-gap: var(--space-half);
  margin-left: var(--space-x3);
  margin-bottom: var(--space);
}

.profile-add-team__team-card {
  padding: var(--space-quarter) var(--space-quarter);
  display: flex;
  align-items: center;
}
.profile-add-team__team-space-and-half {
  padding: var(--space-half) var(--space-half);
    display: grid;
    grid-template-columns: 1fr 0fr;
    justify-content: space-around;
    grid-column-gap: var(--space-and-half);
}

.profile-span-remove-team{
  background-color: var(--new-gray-background-color);
    display: flex;
    justify-content: center;
    align-content: center;
    padding: 5px;
    margin: 0;
    border-radius: 50%;

}

.profile-add-team__card-photo {
  display: flex;
  align-items: center;
}

.profile-add-team__card-photo .icon-ball{
  font-size: calc(var(--space-and-half) + var(--space-quarter));
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    color: var(--white-color);
}

.profile-add-team__card-photo img {
    width: calc(var(--space-x2) + var(--space-half));
    height: calc(var(--space-x2) + var(--space-half)); 
    border-radius: 50%;
}

.profile-add-team__content__title__text {
  color: var(--primary-dark-color) !important;
}

.profile-add-team__card-delete {
  place-self: center;
  cursor: pointer;
}

.profile-add-team__card-delete .icon-minus {
  font-size: var(--space);
  color: var(--basic-gray-color);
  cursor: pointer;
}

.profile-add-team__notfound {
  font-size: var(--space);
  color: var(--basic-red-color);
}

.add-team-form {}
.add-team-form__form {
}
.add-team-form__form__fields {
    padding: var(--space-x2-and-half) var(--space);
}
.add-team-form__form__fields-group {
    display: grid;
    grid-template-columns:  1fr 1fr;
    grid-gap: var(--space-and-half);
}
.add-team-form__form__fields-group .input-field {
    margin: 0;
}
.add-team-form__form__actions {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
    border-top:  1px solid var(--new-input-background-color);
}
.add-team-form__form__input {}

.add-team-form__form__check-input {
    /* margin-left: 8%; */
}

.add-team-form__form__submit {
  margin: var(--space-half);
}
 
/* .profile-add-team-truncate {
  width: 20vw;
} */

.profile-add-team__search_items{
  padding: 0 20%;
}

.profile-add-team__search_items.scroll {
  height: 50vh;
}
.profile-add-team__card-data {
  margin-left: var(--space);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
  .render-profile-modal .modal2__container {
    margin: 0;
    border-radius: 0;
    max-height: unset;
    height: 100%;
  }
  .render-profile-modal .modal2__content {
    height: 100%;
  }
  .render-profile-modal .profile-add-team {
    height: 100%;
  }
  .render-profile-modal .profile-add-team__container {
    width: 100%;
  }
  .render-profile-modal .profile-add-team__search_title {
    margin-left: 0;
  }
  .render-profile-modal .profile-add-team__search_items.scroll {
    height: 100%;
  }
  .render-profile-modal .profile-add-team__search_items {
    padding: 0;
  }
  .add-team-form__form__actions.form__actions .button {
    width: 100%;
  }
  .profile-add-team__card-photo .icon-ball {
    padding: var(--space-quarter);
 }
 
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-teams-modal/ProfileTeamsModalComponent.style.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;AAClD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,sCAAsC;EACtC,gCAAgC;EAChC,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,4CAA4C;IAC1C,aAAa;IACb,8BAA8B;IAC9B,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;EACE,kDAAkD;IAChD,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;IACZ,SAAS;IACT,kBAAkB;;AAEtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;IAC3D,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;IAChD,iDAAiD;IACjD,kBAAkB;AACtB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;AACA;AACA;IACI,8CAA8C;AAClD;AACA;IACI,aAAa;IACb,+BAA+B;IAC/B,+BAA+B;AACnC;AACA;IACI,SAAS;AACb;AACA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,wDAAwD;AAC5D;AACA,6BAA6B;;AAE7B;IACI,qBAAqB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC,4BAA4B;EACnE;IACE,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;CAChC;;AAED","sourcesContent":[".profile-add-team {\n    padding: var(--space-x2-and-half) var(--space);\n}\n\n.profile-add-team__search {\n  display: flex;\n  justify-content: center;\n  margin-bottom: var(--space-and-half);\n}\n.profile-add-team__search_title{\n  margin-left: 20%;\n}\n\n.profile-add-team__search_title.baloa-names{\n  margin-bottom: var(--space-half);\n  color: var(--basic-gray-color);\n}\n\n.profile-add-team__container  {\n  display: flex;\n  border-radius: 5px;\n  overflow: hidden;\n  width: 60%;\n  height: 2.8rem;\n}\n\n.profile-add-team__search-input  {\n  width: 80%;\n  border: 2px solid #ECECEC;\n  background: #ECECEC;\n  border-radius: 5px 0 0 5px;\n  border-right: transparent;\n  padding: 7px;\n  font-family: var(--secondary-font);\n  font-size: var(--space);\n}\n\n.profile-add-team__search-button  {\n  width: 20%;\n  padding: 5px;\n  background-color: #74837C;\n  border: 1px solid transparent;\n}\n\n.profile-add-team__search-button:hover{\n  cursor: pointer;\n}\n\n.profile-add-team__search-button.baloa-table{\n  color: var(--white-color);\n}\n\n.profile-add-team__list {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  grid-column-gap: var(--space-and-half);\n  column-gap: var(--space-quarter);\n  grid-row-gap: var(--space-half);\n  row-gap: var(--space-half);\n  margin-left: var(--space-x3);\n  margin-bottom: var(--space);\n}\n\n.profile-add-team__team-card {\n  padding: var(--space-quarter) var(--space-quarter);\n  display: flex;\n  align-items: center;\n}\n.profile-add-team__team-space-and-half {\n  padding: var(--space-half) var(--space-half);\n    display: grid;\n    grid-template-columns: 1fr 0fr;\n    justify-content: space-around;\n    grid-column-gap: var(--space-and-half);\n}\n\n.profile-span-remove-team{\n  background-color: var(--new-gray-background-color);\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    padding: 5px;\n    margin: 0;\n    border-radius: 50%;\n\n}\n\n.profile-add-team__card-photo {\n  display: flex;\n  align-items: center;\n}\n\n.profile-add-team__card-photo .icon-ball{\n  font-size: calc(var(--space-and-half) + var(--space-quarter));\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    color: var(--white-color);\n}\n\n.profile-add-team__card-photo img {\n    width: calc(var(--space-x2) + var(--space-half));\n    height: calc(var(--space-x2) + var(--space-half)); \n    border-radius: 50%;\n}\n\n.profile-add-team__content__title__text {\n  color: var(--primary-dark-color) !important;\n}\n\n.profile-add-team__card-delete {\n  place-self: center;\n  cursor: pointer;\n}\n\n.profile-add-team__card-delete .icon-minus {\n  font-size: var(--space);\n  color: var(--basic-gray-color);\n  cursor: pointer;\n}\n\n.profile-add-team__notfound {\n  font-size: var(--space);\n  color: var(--basic-red-color);\n}\n\n.add-team-form {}\n.add-team-form__form {\n}\n.add-team-form__form__fields {\n    padding: var(--space-x2-and-half) var(--space);\n}\n.add-team-form__form__fields-group {\n    display: grid;\n    grid-template-columns:  1fr 1fr;\n    grid-gap: var(--space-and-half);\n}\n.add-team-form__form__fields-group .input-field {\n    margin: 0;\n}\n.add-team-form__form__actions {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    border-top:  1px solid var(--new-input-background-color);\n}\n.add-team-form__form__input {}\n\n.add-team-form__form__check-input {\n    /* margin-left: 8%; */\n}\n\n.add-team-form__form__submit {\n  margin: var(--space-half);\n}\n \n/* .profile-add-team-truncate {\n  width: 20vw;\n} */\n\n.profile-add-team__search_items{\n  padding: 0 20%;\n}\n\n.profile-add-team__search_items.scroll {\n  height: 50vh;\n}\n.profile-add-team__card-data {\n  margin-left: var(--space);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n  .render-profile-modal .modal2__container {\n    margin: 0;\n    border-radius: 0;\n    max-height: unset;\n    height: 100%;\n  }\n  .render-profile-modal .modal2__content {\n    height: 100%;\n  }\n  .render-profile-modal .profile-add-team {\n    height: 100%;\n  }\n  .render-profile-modal .profile-add-team__container {\n    width: 100%;\n  }\n  .render-profile-modal .profile-add-team__search_title {\n    margin-left: 0;\n  }\n  .render-profile-modal .profile-add-team__search_items.scroll {\n    height: 100%;\n  }\n  .render-profile-modal .profile-add-team__search_items {\n    padding: 0;\n  }\n  .add-team-form__form__actions.form__actions .button {\n    width: 100%;\n  }\n  .profile-add-team__card-photo .icon-ball {\n    padding: var(--space-quarter);\n }\n \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
